import type { TriggeredCommand } from '@atlassian/butler-command-parser';
import type { SourceType } from '@trello/atlassian-analytics';
import { Analytics } from '@trello/atlassian-analytics';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { getTriggerMetadata } from './CommandMetadata';

export enum ButlerTab {
  Rules = 'rules',
  BoardButton = 'board-button',
  CardButton = 'card-button',
  Schedule = 'scheduled',
  DueDate = 'on-date',
}

export const getButlerTabForRule = (
  command: TriggeredCommand,
): ButlerTab | undefined => {
  const commandType = getTriggerMetadata(command.TRIGGER)?.commandType;
  switch (commandType) {
    case 'rule':
      return ButlerTab.Rules;
    case 'schedule':
      return ButlerTab.Schedule;
    case 'on-date':
      return ButlerTab.DueDate;
    default:
      return;
  }
};

export const ButlerNewCommandId = 'new';

export const showButlerDirectory = async (
  idBoard: string,
  source: SourceType,
  butlerTab?: ButlerTab,
  butlerCmdEdit?: string,
): Promise<void> => {
  // taskSucceeded will be called in setButlerView
  const taskId = Analytics.startTask({
    taskName: 'view-butlerDashboard',
    source,
  });
  try {
    await Controller.getCurrentBoardView().navigateToButlerView({
      tab: butlerTab,
      edit: butlerCmdEdit,
      taskId,
      source,
    });
  } catch (error) {
    Analytics.taskFailed({
      taskName: 'view-butlerDashboard',
      traceId: taskId,
      source,
      error,
    });
  }
};

export const toggleButler = async (): Promise<void> => {
  return Controller.getCurrentBoardView().toggleButlerView();
};
